import { Component, OnInit, ViewChild } from '@angular/core';
import { IListViewConfig, IFormConfig, ValueTypes, InputTypes } from 'app/interfaces';
import { PublicDomainsConfig } from 'app/configs/datasets/public_domains/index';
import { TripPackageConfig } from 'app/configs/datasets/trip_packages/index';
import { PageClosureContainerService } from '../page-closure-container.service';
import { DatasetNavigatorService } from 'app/main/components/dataset/services/dataset-navigator.service';
import { MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'app/services/app.service';
import { DomainFilterService } from 'app/services/domain-filter.service';
import { ActionDialogComponent } from 'app/main/pages/edit-booking/action-dialog/action-dialog.component';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';
import { FormViewerComponent } from 'app/main/components/form-viewer/form-viewer.component';
import { IDomainChangeHandler } from 'app/interfaces/domain-change-handler.interface';
import * as _ from 'lodash';

const ticketlandiaAuthFormConfig: IFormConfig = {
	fields: [
		{
			key: 'marketplace_user_id',
			name: 'User ID',
			valueType: ValueTypes.STRING,
			inputConfig: {
				type: InputTypes.TEXT,
				required: true
			}
		},
		{
			key: 'marketplace_password',
			name: 'Password',
			valueType: ValueTypes.STRING,
			inputConfig: {
				type: InputTypes.TEXT,
				required: true
			}
		}
	]
};

@Component({
	selector   : 'ticketlandia-marketplace-page',
	templateUrl: './marketplace.component.html',
	styleUrls  : ['./marketplace.component.scss'],
	providers: [PageClosureContainerService]
})
export class TicketlandiaMarketplacePageComponent implements OnInit, IDomainChangeHandler{
	public savingCredentials = false;
	public loading = true;
	public domainHasTicketlandiaAccount = false;
	protected _unsubscribeAll: Subject<any>;
	public ticketlandiaAuthFormConfig = ticketlandiaAuthFormConfig;
	public credit:0;
	@ViewChild('ticketlandiaAuthFormViewer', { static: false }) ticketlandiaAuthFormViewer: FormViewerComponent;

	constructor(
		protected appService: AppService,
		protected domainFilterService: DomainFilterService,
		protected datasetNavigatorService: DatasetNavigatorService,
		protected pageClosureContainerService: PageClosureContainerService,
		protected route: ActivatedRoute,
	) {
		this._unsubscribeAll = new Subject();
	}

	handleDomainChanges(): boolean {
		return true;
	}

	checkTicketlandiaAccount(): void{
		this.loading = true;
		this.datasetNavigatorService.datasetService
		.post<any>('/dataset/ticketlandia_tours/command/check_account')
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe(response => {
			this.domainHasTicketlandiaAccount = Boolean(response.valid);
			this.loading = false;
		});
	}

	setTicketlandiaAccount(): void{
		const formData = this.ticketlandiaAuthFormViewer.getFormData();
		this.savingCredentials = true;
		this.ticketlandiaAuthFormViewer.formGroup.disable();
		this.datasetNavigatorService.datasetService
		.post<any>('/dataset/ticketlandia_tours/command/set_account', formData)
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe({
			next: response => {
				this.domainHasTicketlandiaAccount = Boolean(response.valid);
				this.savingCredentials = false;
				this.ticketlandiaAuthFormViewer.formGroup.enable();
			},
			error: response => {
				this.savingCredentials = false;
				this.ticketlandiaAuthFormViewer.formGroup.enable();
				if(response && response.error && response.error.errors) this.ticketlandiaAuthFormViewer.setErrors(response.error.errors);
			}
		});
	}

	ngOnInit(): void {
		if(!this.domainFilterService.filterDomainId.value){
			this.domainFilterService.setFilterDomain(this.route.snapshot.data.domainId);
		}
		
		this.domainFilterService.filterDomainId
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe(domainId => {
			this.checkTicketlandiaAccount();
		});
		this.appService.appEvent.subscribe(event => {
			if(event.extra.datasetCode === 'ticketlandia_tours'){
				console.log(event.extra.paginationResponse.credit);
				this.credit = _.get(event,['extra','paginationResponse','credit'],0);
			}
		})
	}
}
